(function () {
  function initProgress() {
    var bar = document.querySelector('[data-adv-progress]');
    if (!bar) return;
    var fill = bar.querySelector('.adv-progress__fill');
    if (!fill) return;
    function update() {
      var doc = document.documentElement;
      var scrollTop = window.scrollY || doc.scrollTop;
      var scrollHeight = Math.max(doc.scrollHeight, doc.offsetHeight) - window.innerHeight;
      var pct = scrollHeight > 0 ? Math.min(100, Math.max(0, (scrollTop / scrollHeight) * 100)) : 0;
      fill.style.width = pct + '%';
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function initStickyCta() {
    var sticky = document.querySelector('[data-adv-sticky-cta]');
    if (!sticky) return;
    var trigger = document.querySelector('[data-adv-hero]');
    if (!trigger) {
      sticky.classList.add('is-visible');
      return;
    }
    if (!('IntersectionObserver' in window)) {
      sticky.classList.add('is-visible');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.intersectionRatio < 0.1) {
          sticky.classList.add('is-visible');
        } else {
          sticky.classList.remove('is-visible');
        }
      });
    }, { threshold: [0, 0.1], rootMargin: '0px 0px -50% 0px' });
    io.observe(trigger);
  }

  function smoothJumpLinks() {
    document.querySelectorAll('[data-jump]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var target = document.querySelector(link.getAttribute('href') || link.dataset.jump);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initAll() {
    initProgress();
    initStickyCta();
    smoothJumpLinks();
  }

  onReady(initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
